import { ApiSearchService } from "app/services/apiSearch/apiSearch.service";
import SearchService from "app/services/search/search.service";

import {SEARCH_DATE_OPTIONS} from "app/app.types";

const NS = 'GlobalSearchCtrl';

export default function GlobalSearchCtrl($scope, $mdDialog, date) {
  "ngInject";


  var vm = this;

  //-- define public properties
  vm.focused = false;
  vm.loading = false;
  vm.loadError = false;
  vm.moreLoading = false;
  vm.searchLevel = SEARCH_DATE_OPTIONS.FUTURE;
  vm.results = null;
  vm.searchOptions = [{
    label: 'Future Bookings',
    level: SEARCH_DATE_OPTIONS.FUTURE
  }, {
    label: 'Current Day',
    level: SEARCH_DATE_OPTIONS.DAY
  }, {
    label: 'All Bookings',
    level: SEARCH_DATE_OPTIONS.ALL
  }];
  //-- define public methods
  vm.search = search;
  vm.close = close;
  vm.moreAllBookingsResults = moreAllBookingsResults;
  vm.maxSearchResults = 100;
  //-- listen
  $scope.$watch('vm.searchLevel', searchLevelChange);

  function search() {
    if (!vm.searchStr) {
      return;
    }
    if (vm.searchStr.length > 2 && !isNaN(vm.searchStr) || vm.searchStr.length >= 2 && isNaN(vm.searchStr)) {
      vm.loadError = false;
      if (vm.searchStr && vm.searchStr !== '') {
        vm.loading = true;

        if (vm.searchLevel === SEARCH_DATE_OPTIONS.ALL) {
          ApiSearchService.searchAllBookings(vm.searchStr, vm.maxSearchResults).then(result => {
            vm.results = result.bookings;
            vm.bookmark = result.bookmark;
          })
            .catch(searchError).finally(searchCompleted);
        } else {
          SearchService.searchFutureOrToday(vm.searchStr, vm.searchLevel, date).then(function (results) {
            vm.results = results;
          }).catch(searchError).finally(searchCompleted);
        }

      }
    }
  }

  function moreAllBookingsResults() {
    vm.moreLoading = true;
    ApiSearchService.searchAllBookings(vm.searchStr, vm.maxSearchResults, vm.bookmark).then(result => {
      vm.results = vm.results.concat(result.bookings);
      vm.bookmark = result.bookmark;
    })
      .catch(searchError).finally(searchCompleted);
  }

  function searchError() {
    vm.results = [];
    vm.loadError = true;
    vm.bookmark = null;
  }

  function searchError() {
    vm.results = [];
    vm.loadError = true;
  }

  function searchCompleted() {
    vm.loading = false;
    vm.moreLoading = false;
  }

  function close() {
    $mdDialog.hide();
  }

  function searchLevelChange(value, oldValue) {
    if (oldValue && value !== oldValue) {
      search();
    }
  }
}


